import React from "react";
import { CustomIcon, CustomModal } from "../../../../components";
import Context from "../../../../context";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";

import Component from "./Component";

import "./index.sass";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedDriver } = React.useContext(
    Context.DriverScreen
  );
  const [step, setStep] = React.useState<number>(1);
  const [formData, setFormData] = React.useState<ICreateAndUpdateDriver>({
    ...selectedDriver,
  });

  function submitDriverInformation(event: ICreateAndUpdateDriver) {
    setFormData({ ...formData, ...event });
    setStep(2);
  }

  function onBackCarInformation(event: ICreateAndUpdateDriver) {
    setFormData({ ...formData, ...event });
    setStep(1);
  }

  // function submitCarInformation(event: ICreateAndUpdateDriver) {
  //   updateFunction!({ ...formData, ...event });
  // }

  React.useEffect(() => {
    setFormData({ ...selectedDriver });
  }, [selectedDriver]);

  function RenderCreateDriver() {
    switch (step) {
      case 1:
        return (
          <Component.CompanyDriverInformation
            onSubmit={submitDriverInformation}
          />
        );

      default:
        return <></>;
    }
  }

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-update-modal-container">
      <CustomIcon icon="fa fa-add" onClick={() => setShowModal!("CREATE")} />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
      >
        <RenderCreateDriver />
      </CustomModal>
    </section>
  );
};

export default Create;
